<template>
  <svg role="img" :class="['menu-icon', icon, { mask }]">
    <!-- 100%: sprites with their own size (width="24") scale to the icon
         instead of being clipped. -->
    <use
      width="100%"
      height="100%"
      :xlinkHref="`${icons[icon]}#${icon}`"
      :href="`${icons[icon]}#${icon}`"
    />
  </svg>
</template>

<script>
export default {
  name: 'MenuIcon',
  props: {
    icon: { type: String, default: '' },
    mask: { type: Boolean, default: true }
  },
  data: function () {
    return {
      icons: {
        add: require('../../assets/svg/icons/add-square.svg'),
        blockedHouse: require('../../assets/svg/icons/blockedHouse-sprite.svg'),
        chevron: require('../../assets/svg/icons/chevron-right-sprite.svg'),
        close: require('../../assets/svg/icons/close.svg'),
        contract: require('../../assets/svg/icons/check-badge.svg'),
        edit: require('../../assets/svg/icons/cog.svg'),
        heart: require('../../assets/svg/icons/heart-sprite.svg'),
        help: require('../../assets/svg/icons/help-wheel.svg'),
        logout: require('../../assets/svg/icons/lock-2.svg'),
        messages: require('../../assets/svg/icons/conversation-chat.svg'),
        realEstate: require('../../assets/svg/icons/real-estate-house.svg'),
        rocket: require('../../assets/svg/icons/space-rocket-earth.svg'),
        searchSquare: require('../../assets/svg/icons/search-square.svg'),
        search: require('../../assets/svg/icons/search-bar-1.svg'),
        subscription: require('../../assets/svg/icons/rss.svg'),
        swap: require('../../assets/svg/icons/bytesforslag.svg'),
        trash: require('../../assets/svg/icons/trash.svg'),
        wallet: require('../../assets/svg/icons/money-wallet-1.svg'),
        login: require('../../assets/svg/icons/unlock-2.svg'),
        lightbulb: require('../../assets/svg/icons/lightbulb.svg'),
        feedback: require('../../assets/svg/icons/feedback.svg')
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.menu-icon {
  height: 20px;
  width: 20px;
  background-position: center;
  background-size: contain;

  // A menu row can set the colour (--menu-icon-color), e.g. blue on a
  // blue icon tile.
  &.mask {
    fill: var(--menu-icon-color, var(--Text-Primary));
  }

  &.realEstate,
  &.blockedHouse,
  &.swap,
  &.login,
  &.lightbulb,
  &.feedback,
  &.heart {
    fill: none;
    stroke: var(--menu-icon-color, var(--Text-Primary));
    stroke-width: 1.5px;
  }

  // The heart fills the whole width of its box; a bit smaller it weighs as
  // much as the other menu icons.
  &.heart {
    height: 17px;
    width: 17px;
    margin: 1.5px;
  }

  // The chevron at the end of a menu row. Its stroke is set here, not in the
  // sprite, so a hovered row can make it bolder.
  &.chevron {
    height: 16px;
    width: 16px;
    fill: none;
    stroke: var(--menu-icon-color, var(--Text-Primary));
    stroke-width: 1.66667px;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
}
</style>
